import http from '@/http'

export default {
  namespaced: true,
  actions: {
    async updateAddress(context, address) {
      const response = await http.put(`address/${address.id}/`, {
        street: address.street,
        houseNumber: address.houseNumber,
        houseNumber2: address.houseNumber2,
        district: address.district,
        city: address.city,
        postalCode: address.postalCode,
      })

      return response
    },
    async getAddress(context, id) {
      const response = await http.get(`address/${id}`)

      return response
    },
  },
}
